import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { X } from 'lucide-react';
export function WhyNothingWorked() {
  return <section className="py-8 px-4 bg-[#FEF0F3]" data-id="element-379">
      <div className="max-w-3xl mx-auto" data-id="element-380">
        <FadeIn data-id="element-381">
          <h2 className="text-3xl md:text-5xl font-serif text-[#2d1520] mb-4 text-center" data-id="element-382">
            Por qué nada de lo que probaste funcionó
          </h2>
          <p className="text-xl text-[#7a5568] text-center mb-6" data-id="element-383">
            No es que no lo intentaste.
          </p>
        </FadeIn>

        <div className="space-y-4 mb-8" data-id="element-384">
          {['Hablar mejor', 'Callarte', 'Ser más paciente', 'Leer tips', 'Ver videos', 'Pensar "por los chicos"'].map((item, i) => <FadeIn key={item} delay={i * 0.1} data-id="element-385">
              <div className="flex items-center gap-4 p-4 border-b border-[#f0d0dc] opacity-60" data-id="element-386">
                <X className="text-[#c4607a] w-6 h-6" data-id="element-387" />
                <span className="text-lg text-[#7a5568] line-through decoration-[#c4607a]/50" data-id="element-388">
                  {item}
                </span>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn data-id="element-389">
          <div className="text-center space-y-4" data-id="element-390">
            <p className="text-2xl font-serif text-[#c4607a]" data-id="element-391">
              Pero todo eso ataca la discusión, no el patrón.
            </p>

            <div className="relative p-8 bg-white rounded-2xl border border-[#f0d0dc] overflow-hidden shadow-[0_8px_32px_rgba(196,96,122,0.06)]" data-id="element-392">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#c4607a] to-transparent opacity-40" data-id="element-393"></div>
              <p className="text-xl md:text-3xl font-serif text-[#4a2535] leading-relaxed" data-id="element-394">
                "Es como discutir por la humedad sin arreglar la gotera."
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}